import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MaterialCategoryType } from "../../Types/HeyTraderTypes/Materials/MaterialCategoryType";
import { getAllMaterialCategoryList } from "../../Thunks/HeyTraderThunks";

interface MaterialCategorySliceState {
  loader: boolean; // for refres pages and inital loadings
  materialCategoryList: MaterialCategoryType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: MaterialCategorySliceState = {
  loader: false,
  materialCategoryList: [],
  errorDisplay: '',
}

// set state valu for api response
const materialCategorySlice = createSlice({
  name: 'materialCategory',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getAllMaterialCategoryList.rejected, (state, action) => {
      state.loader = false;
      state.errorDisplay = action.error.message!;
    })
      .addCase(getAllMaterialCategoryList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getAllMaterialCategoryList.fulfilled, (state, action: PayloadAction<MaterialCategoryType[]>) => {
        state.loader = false;
        state.materialCategoryList = action.payload;
      })
  }
})

export const { } = materialCategorySlice.actions
export default materialCategorySlice.reducer
